const workercode = () => {
  onmessage = function (e) {
    const staticValueFinder = (componentType, cell) => {
      const value = cell.getValue();
      switch (componentType) {
        case "text":
          return value || "";
        case "datePicker":
          return value || "";
        case "dropdown":
          if (typeof value === "string") {
            return value || "";
          }
          return value?.value || "";
        case "multiSelect":
          if (Array.isArray(value)) {
            return value?.map((el) => el.value).join(" , ") || "";
          } else {
            return "";
          }
        case "dropdown_predictive":
          if (typeof value === "string") {
            return value || "";
          }
          return value?.value || "";
        default:
          return "";
      }
    };

    const { columns, activeData } = JSON.parse(e.data);
    const searchTable = {};
    const rawSearchTable = {};
    const columnsAndCorrespondingContentType = {};
    columns
      ?.map((columnGroup) => {
        return columnGroup.columns;
      })
      .flatMap((el) => el)
      .map((column) => {
        if (column) {
          columnsAndCorrespondingContentType[column.id] = column.componentType;
          return column.id;
        } else {
          return "";
        }
      });

    activeData?.forEach((row, ind) => {
      let acc = {};
      const elem = Object.keys(row).map((el) => {
        const cellObj = {
          getValue: () => {
            return row[el];
          },
          getContext: () => {
            return null;
          },
        };

        const value = staticValueFinder(
          columnsAndCorrespondingContentType[el],

          cellObj
        );
        if (!acc[el]) {
          acc[el] = value;
        }

        return value;
      });
      searchTable[ind] = elem
        .filter((el) => el !== "")
        .join(" ")
        .toLowerCase();
      rawSearchTable[ind] = acc;
    });
    postMessage(
      JSON.stringify({
        searchTable: searchTable,
        rawSearchTable: rawSearchTable,
      })
    );
  };
};

let code = workercode.toString();
code = code.substring(code.indexOf("{") + 1, code.lastIndexOf("}"));

const blob = new Blob([code], { type: "application/javascript" });
const worker_script = URL.createObjectURL(blob);

export default worker_script;
